import StepItem from "./StepItem";

const StepsList = ({ steps, userStatus, isFirstTime }) => {
  console.log("Stepitem ", userStatus);
  console.log("steps", steps);
  console.log("isFirstTime", isFirstTime);

  if (!userStatus) return null;

  const firstIncompleteIndex = steps.findIndex(
    (step) => userStatus[step.key] !== "Completed"
  );

  let disableNextSteps = false;

  return (
    <div className="space-y-6">
      {steps.map((step, index) => {
        const stepStatus = userStatus?.[step.key];
        const isCompleted = stepStatus === "Completed";
        const isReview = stepStatus === "In Review";
        const isCurrentDisabled =
          !isFirstTime && disableNextSteps && !isCompleted;

        // Prevent access to next steps if this one isn't completed
        if (!isCompleted && !isReview) disableNextSteps = true;

        return (
          <StepItem
            key={step.key}
            step={step}
            index={index}
            isDisabled={isCurrentDisabled}
            isFirstTime={isFirstTime}
            status={stepStatus} // pass status string directly
            firstIncompleteIndex={firstIncompleteIndex}
            userStatus={userStatus}
          />
        );
      })}
    </div>
  );
};

export default StepsList;
